module.exports = __webpack_public_path__ + "static/background-696f28e6d157e693e881f920f54fe7f9.png";